import React, { useEffect, useState, lazy, Suspense } from "react";
import { Loading } from "../../shared"; // Assuming you have a loading component
const UserCalendar = lazy(() => import("../../../pages/event/UserCalendar"));
const OpeningTime = lazy(() => import("../../../pages/general/OpeningTime"));
const YouTube = lazy(() => import("./YouTube"));
const Location = lazy(() => import("../../../pages/contactus/Location"));
const SocialMedia = lazy(() => import("../../../pages/contactus/SocialMedia"));

const Landing = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>

      <br />
      <Suspense fallback={<Loading />}>

        <UserCalendar />

      </Suspense>

      <Suspense fallback={<Loading />}>
        <OpeningTime />
      </Suspense>



      <Suspense fallback={<Loading />}>
        <SocialMedia windowWidth={windowWidth} />
      </Suspense>
      <br />

      <Suspense fallback={<Loading />}>
        <Location windowWidth={windowWidth} />
      </Suspense>


      <br />

      <Suspense fallback={<Loading />}>
        <YouTube windowWidth={windowWidth} />
      </Suspense>

    </>
  );
};

export default Landing;
